export default __webpack_public_path__ + "assets/images/d6301d047df50f66c5254c4ddd27388d.png";